import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[toolbar-spacer], toolbar-spacer, [toolbarSpacer]',
})
export class ToolbarSpacerDirective
{
    @HostBinding('style.flex') flexValues = '1 1 auto';
}
